import React from 'react';
import { TitleBar } from 'components/Layouts/TitleBar';
import { FormattedMessage, useIntl } from 'react-intl';
import { Container, Stack, Typography } from '@mui/material';

export const TermsAndConditionsPage = () => {
  const { formatMessage } = useIntl();

  return (
    <Stack flexGrow={1}>
      <TitleBar title={formatMessage({ id: 'TermsAndConditionsPage.Title', defaultMessage: 'Terms of use' })} />
      <Stack flexGrow={1} paddingX={6} sx={{
        backgroundColor: 'grey.100'
      }}>
        <Container maxWidth='xl' sx={{ bgcolor: 'background.paper', pt: 6, flexGrow: 1 }}>
          <Stack gap={4}>
            <Stack gap={1}>
              <Typography variant='body1'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.Body',
                  defaultMessage: 'Please read these terms and conditions carefully before using this website.'
                })
              }</Typography>
            </Stack>

            <Stack gap={1}>
              <Typography textTransform='uppercase' variant='h5'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.General.Title',
                  defaultMessage: 'General'
                })
              }</Typography>
              <Typography>
                <FormattedMessage
                  id='TermsAndConditionsPage.General.Body'
                  defaultMessage={`
                      By using this website, you agree to these terms and conditions, which are governed by the laws of the province of Quebec and the applicable laws of Canada. Please note that you also acknowledge your unconditional agreement to comply with and be bound by these terms and conditions. ARIV Inc. reserves the right to modify or change these terms and conditions from time to time without notice.
                      <p>Your use of this website is at your own risk. Neither ARIV Inc. nor any other party involved in creating, producing or delivering this website is liable for any direct, indirect, incidental, consequential or punitive damages arising out of access to, or use of, this website.</p>
                      <p>ARIV Inc. is in no way responsible for damages caused by browsing the site or downloading elements, data, texts, images or videos. ARIV Inc. makes every effort to ensure that the content of the site is up-to-date and accurate. However, ARIV Inc. does not guarantee that the information appearing on the site is free of errors, inaccuracies or omissions.</p>
                      <p>ARIV Inc. reserves the right to correct any errors or to change the content of the site without notice. In its sole discretion, in addition to all other rights and remedies available to it, and without incurring any liability whatsoever, ARIV Inc. may, at any time and without notice, interrupt or restrict your access to any element of its https://portal.ezdesk.ca website or any related micro-site.</p>
                    `}
                  values={{
                    p: chunks => <p>{chunks}</p>
                  }}
                />
              </Typography>
            </Stack>

            <Stack gap={1}>
              <Typography textTransform='uppercase' variant='h5'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.Divisibility.Title',
                  defaultMessage: 'Divisibility'
                })
              }</Typography>
              <Typography variant='body1'>
                <FormattedMessage
                  id='TermsAndConditionsPage.Divisibility.Body'
                  defaultMessage={'These Terms shall be deemed independent of each other. If any provision of the Terms is held to be unenforceable or invalid, it shall nevertheless be enforced to the fullest extent permitted by applicable law, and the validity and enforceability of the remaining provisions shall not be affected thereby.'}
                />
              </Typography>
            </Stack>

            <Stack gap={1}>
              <Typography textTransform='uppercase' variant='h5'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.Disclaimer.Title',
                  defaultMessage: 'Disclaimer'
                })
              }</Typography>
              <Typography variant='body1'>
                <FormattedMessage
                  id='TermsAndConditionsPage.Disclaimer.Body'
                  defaultMessage={'PLEASE NOTE THAT ALL CONTENT ON THIS WEBSITE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. ARIV INC. DISCLAIMS ALL WARRANTIES OR LIABILITY, EXPRESS OR IMPLIED, ARISING BY OPERATION OF LAW OR OTHERWISE, WITH RESPECT TO THIS WEBSITE OR ANY OTHER WEBSITE LINKED TO IT AND ANY CONTENT ON THIS WEBSITE OR ANY OTHER WEBSITE LINKED TO IT. THIS INCLUDES, BUT IS NOT LIMITED TO, ANY CLAIM IN TORT (INCLUDING NEGLIGENCE). WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, YOU ACKNOWLEDGE THAT ARIV INC. DOES NOT REPRESENT OR WARRANT THAT THIS WEBSITE WILL BE AVAILABLE WITHOUT INTERRUPTION.'}
                />
              </Typography>
            </Stack>

            <Stack gap={1}>
              <Typography textTransform='uppercase' variant='h5'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.LimitationOfLiability.Title',
                  defaultMessage: 'Limitation of liability'
                })
              }</Typography>
              <Typography variant='body1'>
                <FormattedMessage
                  id='TermsAndConditionsPage.LimitationOfLiability.Body'
                  defaultMessage={'ARIV INC, ITS OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES, SUCCESSORS OR ASSIGNS, AND OTHER REPRESENTATIVES SHALL NOT BE LIABLE TO YOU OR ANY OTHER PERSON UNDER ANY THEORY OF LIABILITY, INCLUDING WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE - ACTIVE, OR ANY OTHER PERSON, UNDER ANY THEORY OF LIABILITY, INCLUDING WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE - ACTIVE, PASSIVE OR IMPLIED), PRODUCT LIABILITY OR STRICT LIABILITY, FOR DAMAGES (INCLUDING DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR CONSEQUENTIAL DAMAGES) ARISING OUT OF OR IN CONNECTION WITH THE USE, INABILITY TO USE, OR THE RESULTS OF THE USE OF THIS WEBSITE OR THE CONTENT THEREOF, EVEN IF ARIV INC. OR ITS REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF YOU ARE DISSATISFIED WITH THIS SITE AND ITS CONTENTS, OR WITH THE TERMS AND CONDITIONS, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THIS SITE. IF ANY PART OF THIS LIMITATION CLAUSE IS HELD INVALID OR UNENFORCEABLE FOR ANY REASON, ARIV INC. S LIABILITY TO YOU SHALL IN NO EVENT EXCEED ONE HUNDRED DOLLARS ($100) IN THE AGGREGATE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CERTAIN TYPES OF DAMAGES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.'}
                />
              </Typography>
            </Stack>

            <Stack gap={1}>
              <Typography textTransform='uppercase' variant='h5'>{
                formatMessage({
                  id: 'TermsAndConditionsPage.OwnershipAndUseOfSite.Title',
                  defaultMessage: 'Ownership and use of site'
                })
              }</Typography>
              <Typography>
                <FormattedMessage
                  id='TermsAndConditionsPage.OwnershipAndUseOfSite.Body'
                  defaultMessage={`
                      All content, without limitation, all text, design, graphics, drawings, photos, code and software of any organization and the presentation of such content, which forms this website, is subject to intellectual property rights, including copyrights, trademarks, trade names, words, advertising slogans and logos used under license by ARIV Inc. or its associates. All such rights are reserved. The use of certain trademarks, trade names, logos and images is the property of their respective owners, and unless authorized, will constitute a violation of the respective owner's rights.
                      <p>The ARIV Inc. website (https://portal.ezdesk.ca) may not, in whole or in part, be copied, reproduced, republished, downloaded, displayed, transmitted or distributed without the written consent of ARIV Inc. However, you may download, view and print the documents presented on https://portal.ezdesk.ca solely for personal, non-commercial use. Unauthorized use of https://portal.ezdesk.ca or the materials on the site may violate copyright, trademark, intellectual property or other applicable laws. You may not alter the copyright and trademark notices, including any other proprietary notices, contained in the materials. You may not use such materials on any other website or in any networked computer environment. Furthermore, it is forbidden to modify in any way any document printed from the https://portal.ezdesk.ca website.</p>
                      <p>2023 ARIV Inc. All rights reserved.</p>
                    `}
                  values={{
                    p: chunks => <p>{chunks}</p>
                  }}
                />
              </Typography>
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
};